<template>
  <Header></Header>

  <main>
    <router-view />
  </main>

  <Footer></Footer>
</template>

<script setup lang="ts">
import Header from "@/components/Header/index.vue";
import Footer from "@/components/Footer/index.vue";
</script>
